let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9DGIJ")).then(() => parcelRequire('in4So'));